import React from "react";

const Example = ({
  id,
  title,
  description,
  sourceCode,
  setSourceCode,
  lastChanger,
  setLastChanger,
}) => {
  return (
    <details>
      <summary className="btn btn-light m-2">{String(title)}</summary>
      <p className="m-2"> {String(description)}</p>
      <div className="border border-secondary rounded bg-light m-2">
        <pre className="pre-scrollable">
          <code>{String(sourceCode)}</code>
        </pre>
      </div>
      <center>
        <button
          disabled={Boolean(lastChanger === id)}
          className="btn btn-primary m-2"
          onClick={() => {
            setLastChanger(id);
            setSourceCode(String(sourceCode));
          }}
        >
          Paste Into Code Field
        </button>
      </center>
    </details>
  );
};

export default Example;
